/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { JobsControllerGetOrgFairnessQueryResponse, JobsControllerGetOrgFairnessQueryParams, JobsControllerGetOrgFairness401, JobsControllerGetOrgFairness403 } from "../../models/jobsController/JobsControllerGetOrgFairness";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { jobsControllerGetOrgFairness } from "../../clients/jobsService/jobsControllerGetOrgFairness";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const jobsControllerGetOrgFairnessQueryKey = (params: JobsControllerGetOrgFairnessQueryParams = {}) => [{
  url: '/api/v1/jobs/org-fairness'
}, ...(params ? [params] : [])] as const;
export type JobsControllerGetOrgFairnessQueryKey = ReturnType<typeof jobsControllerGetOrgFairnessQueryKey>;
export function jobsControllerGetOrgFairnessQueryOptions(params?: JobsControllerGetOrgFairnessQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = jobsControllerGetOrgFairnessQueryKey(params);
  return queryOptions<JobsControllerGetOrgFairnessQueryResponse, ResponseErrorConfig<JobsControllerGetOrgFairness401 | JobsControllerGetOrgFairness403>, JobsControllerGetOrgFairnessQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return jobsControllerGetOrgFairness(params, config);
    }
  });
}

/**
 * @description Returns PROCESSING/QUEUED counts and best queued priority per organization for one worker pool queue (default chat-job-queue), ordered by fewest running then most queued — the order the worker-monitor claimer uses to pick the next org.
 * @summary Get per-org job fairness snapshot
 * {@link /api/v1/jobs/org-fairness}
 */
export function useJobsControllerGetOrgFairness<TData = JobsControllerGetOrgFairnessQueryResponse, TQueryData = JobsControllerGetOrgFairnessQueryResponse, TQueryKey extends QueryKey = JobsControllerGetOrgFairnessQueryKey>(params?: JobsControllerGetOrgFairnessQueryParams, options: {
  query?: Partial<QueryObserverOptions<JobsControllerGetOrgFairnessQueryResponse, ResponseErrorConfig<JobsControllerGetOrgFairness401 | JobsControllerGetOrgFairness403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? jobsControllerGetOrgFairnessQueryKey(params);
  const query = useQuery({
    ...jobsControllerGetOrgFairnessQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<JobsControllerGetOrgFairness401 | JobsControllerGetOrgFairness403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}